import React from 'react';

interface DrawerContextType {
  consumePopoutActionFromMain: () => string | null;
  drawerHeight: number;
  expandDrawer: () => void;
  handoffPopoutActionToMain: (actionType: string) => boolean;
  isPopped: boolean;
  popoutHeight: number | null;
  reopenPopoutIfNeeded: () => void;
  setDrawerHeight: (height: number) => void;
}

const DrawerContext = React.createContext<DrawerContextType>({
  consumePopoutActionFromMain: () => null,
  drawerHeight: 0,
  expandDrawer: () => {},
  handoffPopoutActionToMain: () => false,
  isPopped: false,
  popoutHeight: null,
  reopenPopoutIfNeeded: () => {},
  setDrawerHeight: () => {},
});

export default DrawerContext;

export const useDrawerContext = () => React.useContext(DrawerContext);
